import { createRouter, createWebHistory } from 'vue-router';

const publicRoutePrefix = '/public/';
export const isPublicRoute = (path: string) => path.startsWith(publicRoutePrefix);
const getRouter = () => {
    const router = createRouter({
        history: createWebHistory(),
        routes: [
            {
                path: publicRoutePrefix,
                children: [
                    {
                        path: 'sign-off-envelope/:accessToken',
                        name: 'PublicSignOffEnvelope',
                        component: () => import('@/external/views/ExternalSignOffEnvelopeByToken.vue'),
                        props: true,
                    },
                    {
                        path: '/:catchAll(.*)*',
                        component: () => import('@/external/views/ExternalNotFound.vue'),
                    },
                ],
            },
        ],
    });

    // No navigation guards for public routes - completely open access
    console.log('[PublicRouter] Router created with', router.getRoutes().length, 'routes');

    return router;
};

export const router = getRouter();
